<div class="d-flex" id="wrapper">
  <user-sidebar [collapsed]="isSidebarCollapsed" />

  <div class="main-content flex-grow-1">
    <user-header (toggleSidebar)="toggleSidebar()" />

    <div class="container-fluid mt-3 p-3 content-area">
      <div class="dashboard-wrapper">
        <div class="rounded p-4 card-bg-main">
          <router-outlet />
        </div>
      </div>
    </div>

    <user-footer />
  </div>
</div>
